<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.report_history') }}</span>
    </div>
    <div class="page-card-content pt-20">
      <div class="page-content" style="max-width: unset;">
        <el-table
          border
          size="mini"
          :data="data"
          v-loading="loading"
          height="calc(100vh - 260px)"
        >
          <el-table-column
            :label="$t('text.facility')"
            prop="BuildingName"
          ></el-table-column>
          <el-table-column :label="$t('text.period')" width="500px">
            <template slot-scope="scope">
              <div>
                {{ $t('text.period') }} 1 ({{ $t('text.baseline') }}):
                {{ scope.row.BaselineFromDate }} -
                {{ scope.row.BaselineToDate }}
              </div>
              <div>
                {{ $t('text.period') }} 2 ({{ $t('text.trial') }}):
                {{ scope.row.TrialFromDate }} -
                {{ scope.row.TrialToDate }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('text.status')">
            <template slot-scope="scope">
              <el-tag :type="statusType(scope.row.Status)">{{
                scope.row.Status
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('text.created_date')"
            prop="CreatedDateTime"
          >
          </el-table-column>
          <el-table-column :label="$t('text.action')">
            <template slot-scope="scope">
              <div
                class="blue-font underline pointer inline-block"
                @click="downloadReport(scope.row)"
                v-if="scope.row.Status === 'COMPLETED'"
              >
                <span>{{ $t('text.download') | firstLetterCapitalize }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import moment from 'moment-timezone'
import { storageUrl } from '@/const'
export default {
  data() {
    return {
      loading: false,
      data: [],
      timer: null
    }
  },
  mounted() {
    this.getData()
    this.timer = setInterval(() => this.getData(false), 10000)
  },
  methods: {
    getData(showLoading = true) {
      if (showLoading) this.loading = true
      ApiService.GetOrganisationReportHistory(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.data = response.data.data.map(item => {
              return {
                ...item,
                BuildingName: item.Name,
                BaselineFromDate: moment(item.BaselineFromDate).format(
                  'YYYY-MM-DD HH:mm:ss'
                ),
                BaselineToDate: moment(item.BaselineToDate).format(
                  'YYYY-MM-DD HH:mm:ss'
                ),
                TrialFromDate: moment(item.TrialFromDate).format(
                  'YYYY-MM-DD HH:mm:ss'
                ),
                TrialToDate: moment(item.TrialToDate).format(
                  'YYYY-MM-DD HH:mm:ss'
                ),
                CreatedDateTime: moment
                  .utc(item.CreatedDateTime)
                  .tz(moment.tz.guess(true))
                  .format('YYYY-MM-DD HH:mm:ss')
              }
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    statusType(status) {
      // status: pending, initiated, failed, complete
      if (status === 'FAILED') {
        return 'danger'
      } else if (status === 'COMPLETED') {
        return 'success'
      } else if (status === 'INITIATED') {
        return 'info'
      }
      return ''
    },
    downloadReport(item) {
      if (item.Status !== 'COMPLETED') return
      if (!item.FileName) {
        swal({
          icon: 'error',
          timer: 2000,
          title: this.$t('text.failed')
        })
        return
      }
      window.open(`${storageUrl}/uploads/${item.FileName}`, '_blank')
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
